<template>
  <Card class="w-full max-w-md mx-auto">

    <CardHeader>
      <CardTitle>{{ $t(`auth.${setPasswordType}.enter-opt-code.title`) }}</CardTitle>

      <CardDescription
          v-html="
          $t(`auth.${setPasswordType}.enter-opt-code.text`, {
            phone: resetPasswordData.phoneMask,
          })
        "
      />
    </CardHeader>

    <CardContent>
      <div v-if="error" class="flex justify-center text-sm text-red-600 mb-4">
        <div v-if="attemptsLeft !== null && attemptsLeft > 1" class="flex justify-center text-sm text-red mb-4">
          {{ $t('auth.otp.attempts_left', {count: attemptsLeft}) }}
        </div>
        <div v-else-if="attemptsLeft === 1" class="flex justify-center text-sm text-red mb-4">
          {{ $t('auth.otp.attempts_left_one', {count: attemptsLeft}) }}
        </div>
        <div v-else class="flex justify-center text-sm text-red mb-4">
          {{ $t('auth.otp.attempts_used') }}
        </div>
      </div>

      <div class="flex justify-center">
        <PinInput
            id="pin-input"
            v-model="otpCode"
            placeholder="-"
        >
          <PinInputGroup>
            <PinInputSlot
                v-for="(id, index) in 4"
                :key="id"
                :index="index"
                class="w-12 h-12 text-lg border-gray-300"
                :class="{
                'border-red-500': hasError,
                'border-gray-300': !hasError
                }"
            />
          </PinInputGroup>
        </PinInput>
      </div>
    </CardContent>

    <CardFooter>
      <Button
          class="w-full bg-[#64748B] transition-colors hover:bg-[#64748B] hover:opacity-75"
          :disabled="isDataLoading || !isFormValid"
          @click="verifyOTPCode"
      >
        {{ $t(`auth.${setPasswordType}.enter-opt-code.actions.continue`) }}
      </Button>
    </CardFooter>
  </Card>
</template>

<script>
// Импорт компонентов
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
} from '@/components/ui/card'

import {
  PinInput,
  PinInputGroup,
  PinInputSlot,
} from "@/components/ui/pin-input"

import {Button} from "@/components/ui/button"
import {mapState} from 'vuex'
import {UserApi} from '@js-app/office/api/user-api'

export default {
  name: 'EnterCode',
  components: {
    Card,
    CardHeader,
    CardTitle,
    CardDescription,
    CardContent,
    CardFooter,
    PinInput,
    PinInputGroup,
    PinInputSlot,
    Button
  },
  props: {
    hash: String,
  },
  data() {
    return {
      otpCode: [],
      isDataLoading: false,
      error: null,
      attemptsLeft: null,
      OTP_LENGTH: 4,
      hasError: false
    }
  },
  computed: {
    ...mapState({
      resetPasswordData: (state) => state.appState.resetPasswordState,
    }),
    setPasswordType() {
      return this.$route.meta.setPasswordType || 'forgot-password'
    },

    isFormValid() {
      return this.otpCode.length === this.OTP_LENGTH;
    }
  },
  methods: {
    async verifyOTPCode() {
      const otpCodeString = Array.isArray(this.otpCode) ? this.otpCode.join("") : this.otpCode;

      if (otpCodeString.length !== this.OTP_LENGTH) {
        this.error = this.$t('auth.otp.code_length_error');
        return;
      }

      this.isDataLoading = true;
      this.error = null;
      this.attemptsLeft = null;
      this.hasError = false;

      try {
        const verifyOTPResponse = await UserApi.verifyOTPCode(otpCodeString);
        this.error = null;

        await this.$router.push({
          name: `${this.setPasswordType}-password`,
          params: {
            hash: this.hash,
          },
        })
      } catch (e) {
        const responseData = e.data;

        if (responseData) {
          this.error = responseData.message || this.$t('auth.otp.invalid_code');
          this.attemptsLeft = responseData.attempts_left;
          this.hasError = true;

          if (responseData.redirect_to_error) {
            await new Promise(resolve => setTimeout(resolve, 1500));
            this.$router.push({name: 'login-otp-error'});
          }
        } else {
          this.hasError = true;
        }

      } finally {
        this.isDataLoading = false
      }
    },
  },
}
</script>

<style scoped>
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
</style>
